module.exports = __webpack_public_path__ + "static/media/banner_2.eb21b245.jpg";